import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref } from "vue";
import tinycolor from "tinycolor2";

const SCROLL_HINT_COLOR_PARAM = "scroll_hint_color";
const DEFAULT_PRIMARY_COLOR = "#000000";


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollHint',
  props: {
    primaryButtonColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "732ecca8": (backgroundColor.value),
  "53d03681": (iconColor.value)
}))

const props = __props;

const visible = ref(false);

let resizeObserver: ResizeObserver | undefined;
let mutationObserver: MutationObserver | undefined;
let scrollRoot: Element | null = null;
let observedView: Element | null = null;
let rafId = 0;

function getQueryScrollHintColor(): string | null {
  const value = new URLSearchParams(window.location.search).get(
    SCROLL_HINT_COLOR_PARAM,
  );
  if (!value) {
    return null;
  }
  // Allow any CSS color; reject empty / whitespace-only values.
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

const queryScrollHintColor = getQueryScrollHintColor();

const backgroundColor = computed(() => {
  return (
    queryScrollHintColor ||
    props.primaryButtonColor ||
    DEFAULT_PRIMARY_COLOR
  );
});

const iconColor = computed(() => {
  const color = tinycolor(backgroundColor.value);
  return color.isLight() ? "black" : "white";
});

function getScrollRoot(): Element {
  return (
    document.querySelector(".app-shell") ||
    document.scrollingElement ||
    document.documentElement
  );
}

function updateVisibility() {
  const root = scrollRoot || getScrollRoot();
  const { scrollTop, clientHeight, scrollHeight } = root;
  const hasOverflow = scrollHeight > clientHeight + 1;
  const atBottom = scrollTop + clientHeight >= scrollHeight - 2;
  visible.value = hasOverflow && !atBottom;
}

/** Wait for layout after DOM/size changes, then re-check overflow. */
function scheduleUpdateVisibility() {
  cancelAnimationFrame(rafId);
  rafId = requestAnimationFrame(() => {
    ensureViewObserved();
    updateVisibility();
  });
}

function ensureViewObserved() {
  if (!resizeObserver) {
    return;
  }
  const viewElement = document.querySelector(".view");
  if (viewElement && viewElement !== observedView) {
    if (observedView) {
      resizeObserver.unobserve(observedView);
    }
    observedView = viewElement;
    resizeObserver.observe(viewElement);
  }
}

function scrollForMore() {
  const root = scrollRoot || getScrollRoot();
  root.scrollBy({
    top: Math.round(root.clientHeight * 0.75),
    behavior: "smooth",
  });
}

onMounted(() => {
  scrollRoot = getScrollRoot();
  scrollRoot.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility);
  window.addEventListener("load", scheduleUpdateVisibility);

  if (typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(() => {
      scheduleUpdateVisibility();
    });
    // Shell's border-box often stays fixed; .view size changes when content loads.
    ensureViewObserved();
  }

  if (typeof MutationObserver !== "undefined") {
    mutationObserver = new MutationObserver(() => {
      scheduleUpdateVisibility();
    });
    mutationObserver.observe(scrollRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  scheduleUpdateVisibility();
});

onUnmounted(() => {
  cancelAnimationFrame(rafId);
  scrollRoot?.removeEventListener("scroll", updateVisibility);
  window.removeEventListener("resize", updateVisibility);
  window.removeEventListener("load", scheduleUpdateVisibility);
  resizeObserver?.disconnect();
  mutationObserver?.disconnect();
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "scroll-hint",
    "aria-label": "More content below",
    title: "Scroll for more",
    onClick: scrollForMore
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("svg", {
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      focusable: "false"
    }, [
      _createElementVNode("path", {
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "3.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M6 9l6 6 6-6"
      })
    ], -1)
  ]), 512)), [
    [_vShow, visible.value]
  ])
}
}

})